import { ref, computed, nextTick } from 'vue'

export function usePdfNavigation(pages, scrollToPageFn) {
  const currentPage = ref(1)

  const canNext = computed(() => currentPage.value < pages.value)
  const canPrev = computed(() => currentPage.value > 1)

  const goToPage = async (n) => {
    if (n < 1 || n > pages.value) return
    currentPage.value = n
    await nextTick()
    scrollToPageFn?.(n)
  }

  const nextPage = () => canNext.value && goToPage(currentPage.value + 1)
  const previousPage = () => canPrev.value && goToPage(currentPage.value - 1)

  return {
    currentPage,
    canNext,
    canPrev,
    nextPage,
    previousPage,
    goToPage
  }
}
